// List of all products

let products = [
    {
        productName: 0,
        productPrice: 0
    },
    {
        productName: '3x3oz Pack',
        productPrice: 29.9
    },
    {
        productName: '3x1oz Pack',
        productPrice: 22.9
    }
    
]

let colors = {
    silver: 0.0,
    black: 3.0,
    blue: 5.0,
    red: 5.0,
    green: 5.0,
}


var colorPrice = 0;
// DPD shipping cost up to 2kg

let shippingCostList = {
    // Do 1.5 kg

    // EU ki niso clanice
    Europe: 16.40,

    Americas: 23.50,
    Africa: 23.50,
    Oceania: 23.50,
    Asia: 23.50,
    
    // Clanice EU
    SI: 4.80,
    DE: 11.70,
    BE: 11.70,
    BG: 11.70,
    CZ: 11.70,
    DK: 11.70,
    EE: 11.70,
    IE: 11.70,
    EL: 11.70,
    ES: 11.70,
    FR: 11.70,
    HR: 11.70,
    IT: 11.70,
    CY: 11.70,
    LV: 11.70,
    LT: 11.70,
    LU: 11.70,
    HU: 11.70,
    MT: 11.70,
    NL: 11.70,
    AT: 11.70,
    PL: 11.70,
    PT: 11.70,
    RO: 11.70,
    SK: 11.70,
    FI: 11.70,
    SE: 11.70,
}


// get selected item's price and set it to it's pricetag
function updateItemPrice(selectedValue, pId){
    var parentId = 'item-block-' + JSON.stringify(pId);
    // var parentId = that.parentNode.parentNode.parentNode.parentNode.parentNode.id; //get parent id
    // console.log(parentId);
    // console.log(that)
    
    var priceNode = document.getElementById(parentId).getElementsByClassName('priceTag')[0]; // find pricetag
    // console.log(priceNode)

    if(selectedValue){
       
        // If value is not null then set price to corespondant item

        var getProductPrice = products[selectedValue].productPrice;
        // console.log(getProductPrice);
        priceNode.dataset.priceTag = getProductPrice;
        priceNode.textContent = getProductPrice + '0€';

    }else{ 

        // else set the price to 0

        // console.log('null'); 
        priceNode.textContent = '0.00€';
        priceNode.dataset.priceTag = 0;
    }

    updateTotalPrice();
    
}

var GLOBALCOUNT = 1;

// Generate new BLOCK

function generateItemBlock(){
    GLOBALCOUNT = GLOBALCOUNT + 1;

    var totalBlocks = document.querySelectorAll('.priceTag').length;
    console.log(totalBlocks)
    var OrderForm = document.getElementById('contact-form');
    var endTarget = document.getElementById('endTarget');

    var newDiv = document.createElement('div');

    newDiv.setAttribute('id', 'item-block-' + GLOBALCOUNT);
    newDiv.setAttribute('class', 'row');

    const newContent = `
            
            
            <div class="col-12 form-line mb-4"></div>
            <input type="hidden" name="Item&nbsp;Number${GLOBALCOUNT}" value="">
            <div class="col col-12 col-md-4">
            <label class="d-md-none" for="product-name-${GLOBALCOUNT}">Select Product</label>
            <div class="row mt-2 mt-md-0">
                <div class="col col-12">
                <div class="input-group">
                    <select class="form-select form-control" id="product-name-${GLOBALCOUNT}" name="Product${GLOBALCOUNT}" required onchange="updateItemPrice(this.value, ${GLOBALCOUNT});">
                    <option selected value=""></option>
                    <option value="1">3 x 3oz Pack</option>
                    <option value="2">3 x 1oz Pack</option>
                    </select>
                </div>
                </div>
            </div>
            </div>
            <div class="col col-6 col-md-2 mt-3 mt-md-0">
            <label class="d-md-none" for="product-thread-${GLOBALCOUNT}">Thread</label>
            <div class="row mt-2 mt-md-0">
                <div class="col col-12">
                <div class="input-group">
                    <select class="form-select form-control" id="product-thread-${GLOBALCOUNT}" name="Thread${GLOBALCOUNT}" required>
                    <option selected value=""></option>
                    <option value="1">5/16-24</option>
                    <option value="2">1/4-20</option>
                    </select>
                </div>
                </div>
            </div>
            </div>
            <div class="col col-6 col-md-2 mt-3 mt-md-0">
            <label class="d-md-none" for="product-color-${GLOBALCOUNT}">Color</label>
            <div class="row mt-2 mt-md-0">
                <div class="col col-12">
                <div class="input-group">
                    <select class="form-select form-control" id="product-color-${GLOBALCOUNT}" name="Color${GLOBALCOUNT}" requiered>
                    <option selected>Silver</option>
                    </select>
                </div>
                </div>
            </div>
            </div>
            <div class="col col-6 col-md-2 mt-3 mt-md-0">
            <label class="d-md-none" for="product-quantity-${GLOBALCOUNT}">Quantity</label>
            <div class="row mt-2 mt-md-0">
                <div class="col col-12">
                <div class="input-group">
                    <input type="number" class="form-control quantityTag" id="product-quantity-${GLOBALCOUNT}" value="1" min="1" max="20" name="Quantity${GLOBALCOUNT}" required onchange="updateTotalPrice();">
                    <div class="invalid-feedback">
                        Max 20
                    </div>
                </div>
                </div>
            </div>
            </div>
            <div class="col col-6 col-md-2 mt-3 mt-md-0">
            <label class="d-md-none" for="product-name">Price/Unit</label>
            <div class="row mt-2 mt-md-0" style="height: 38px;">
                <div class="col col-12 d-flex align-items-center">
                <span class='priceTag' data-price-tag="0">0.00€</span>
                </div>
            </div>
            </div>
            <div class="col-12">
                <button type="button" class="btn-remove mt-3 mt-md-1" onclick="removeFromList('item-block-${GLOBALCOUNT}');">Remove From Cart</button>
            </div>
  
  `

    if(totalBlocks <= 6){
        newDiv.innerHTML = newContent; // Add innerHtml
        OrderForm.insertBefore(newDiv, endTarget); // Insert before total price

    }
    else{
        return;
    }

}


// function refresh prices 
// update everytime a change happnes


function updateTotalPrice(){

    var totalPriceEl = document.getElementById('totalPrice');
    var priceTotal = 0;
    var priceTags = document.querySelectorAll('.priceTag');
    var quantityTags = document.querySelectorAll('.quantityTag');


    priceTags.forEach((tag, index)=>{
        // console.log(tag.dataset.priceTag);
        var tagValue = parseFloat(tag.dataset.priceTag);

        var quantityValue = quantityTags[index].value; // get quantity and multiply it by the price of item


        // console.log(tagValue);
        priceTotal = (tagValue * quantityValue) + priceTotal;

    })


    priceTotal = priceTotal + globalShippingPrice;
    priceTotalRounded = priceTotal.toFixed(2);

    totalPriceEl.textContent = priceTotalRounded + '€';
    // console.log(priceTotal);

}


// When pressed remove btn remove block form list
function removeFromList(blockid){
    const block = document.getElementById(blockid)

    block.remove();

    updateTotalPrice();
}

var globalShippingPrice = 0;

function updateShipping(countryId){
    var shippingEl = document.getElementById('shippingCost');
    var region = document.querySelector('#country option:checked').parentElement.label; // get region
    
    var shippingCost;


    // check if in EU and more specific in EU Union
    if(region === 'Europe'){
        shippingCost = shippingCostList[countryId];

        if(shippingCost === undefined){
            shippingCost = shippingCostList[region];
        }
    }else if(!region){ // For html estethics
        shippingCost = 0;
    }else{ //Else add price for that continent
        shippingCost = shippingCostList[region];
    }

    globalShippingPrice = shippingCost; // saving for total price to know what the shipping costs are

    console.log(shippingCost);

    // dont display shipping cost if it's 0
    if(!shippingCost == 0){
        shippingEl.innerText = shippingCost + '0€';
    }else{
        shippingEl.innerText = '0.00€';
    }

    updateTotalPrice();
}


function updateColor(color, pId){
    console.log(color);
    colorPrice = colors[color];
    console.log(colorPrice);
    //update item price

    
    var parentId = 'item-block-' + JSON.stringify(pId);
    var priceNode = document.getElementById(parentId).getElementsByClassName('priceTag')[0];
    
    var priceCurrentValue = parseFloat(priceNode.dataset.priceTag)
    console.log(priceCurrentValue)

    var combinedItemPrice = priceCurrentValue + colorPrice;

    priceNode.dataset.priceTag = combinedItemPrice;
    priceNode.innerText = combinedItemPrice;
    
    // OPOZORILO RESET VALUE TO ORIGINAL PRICE BEFORE ADDING COLOR PRICE

    updateTotalPrice();
}